import {ValueObject} from '@s-ui/domain'

import {ImageSharedValueObject} from '../../shared/ValueObjects/ImageSharedValueObject.js'

export class ListImagesValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Array} params.items
   * */
  #value

  constructor({value = []} = {}) {
    super()
    this.#value = value
  }

  static empty() {
    return new ListImagesValueObject({value: []})
  }

  static create({images = []} = {}) {
    return new ListImagesValueObject({value: images.map(item => ImageSharedValueObject.create({value: item}))})
  }

  static createFromVehicleImages({items = []} = {}) {
    return new ListImagesValueObject({value: items.map(({url}) => ImageSharedValueObject.create({value: url}))})
  }

  get value() {
    return this.#value.map(image => image.value)
  }

  isEmpty() {
    return this.#value.length === 0
  }

  toJSON() {
    return {images: this.#value.map(image => image.value)}
  }
}
